import { verify, constrain, Type, Constraint, optional, either, adjust } from 'specified';
import { v4 } from 'uuid';
import isNil from 'lodash/isNil';
import omitBy from 'lodash/omitBy';
import { QueryString, optionalKey } from '@grandvisionhq/utils';
import { useReducer, useEffect } from 'react';

var types$7 = /*#__PURE__*/Object.freeze({
    __proto__: null
});

/*! *****************************************************************************
Copyright (c) Microsoft Corporation.
Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.
THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
function __rest(s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
}
function __awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function __generator(thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
}
function __read(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
}
function __spreadArray(to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || from);
}

var okOrThrow = function (response) {
    if (!response.ok) {
        var error = new Error("Request to " + response.url + " failed: " + response.status + " - " + response.statusText + ".");
        error.statusCode = response.status;
        throw error;
    }
};
function okOrThrowWithResponseError(response) {
    return __awaiter(this, void 0, void 0, function () {
        var isHandled, result, error, error_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (response.ok) {
                        return [2 /*return*/];
                    }
                    isHandled = false;
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, response.json()];
                case 2:
                    result = _a.sent();
                    error = new Error(result.message);
                    error.statusCode = response.status;
                    isHandled = true;
                    throw error;
                case 3:
                    error_1 = _a.sent();
                    // check if the error is already handled
                    if (isHandled) {
                        throw error_1;
                    }
                    // otherwise fallback to default error handling
                    okOrThrow(response);
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    });
}
var unwrapResponse = function (response, options) {
    if (options === void 0) { options = {}; }
    return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (response.status === 422) {
                        return [2 /*return*/, response.json().then(function (error) {
                                throw error;
                            })];
                    }
                    if (!options.useResponseError) return [3 /*break*/, 2];
                    return [4 /*yield*/, okOrThrowWithResponseError(response)];
                case 1:
                    _a.sent();
                    return [3 /*break*/, 3];
                case 2:
                    okOrThrow(response);
                    _a.label = 3;
                case 3: return [4 /*yield*/, response.json()];
                case 4: return [2 /*return*/, (_a.sent())];
            }
        });
    });
};
// eslint-disable-next-line @typescript-eslint/no-explicit-any
var validateResponse = function (spec, response) { return __awaiter(void 0, void 0, void 0, function () {
    var _a, err, value, _b, _c;
    return __generator(this, function (_d) {
        switch (_d.label) {
            case 0:
                okOrThrow(response);
                _b = verify;
                _c = [spec];
                return [4 /*yield*/, response.json()];
            case 1:
                _a = _b.apply(void 0, _c.concat([_d.sent()])), err = _a.err, value = _a.value;
                if (err) {
                    throw err;
                }
                return [2 /*return*/, value()];
        }
    });
}); };

var jsonMimeType = 'application/json';
var acceptJson = {
    Accept: jsonMimeType,
};
var postJson = {
    'Content-Type': jsonMimeType,
};
var authHeader = function (accessToken) { return ({
    Authorization: "Bearer " + accessToken,
}); };
var correlationHeader = function () {
    return { 'X-Correlation-ID': v4() };
};
var acceptLanguageHeader = function (locale) {
    return locale ? { 'Accept-Language': locale } : {};
};

var integerSpec = constrain(Type.number, [Constraint.number.integer]);
var positiveIntegerSpec = constrain(integerSpec, [Constraint.number.atLeast(0)]);
var integerAbove0$1 = constrain(integerSpec, [Constraint.number.above(0)]);
constrain(Type.string, [Constraint.string.notEmpty]);
var isoDateSpec = Type.string; // @TODO: Need more spec constraints
// copied and adapted from the obsolete dateString type https://github.com/tbknl/specified/blob/v0.4.0/src/type.ts
var dateStringSpec = {
    version: 1,
    definition: {
        type: 'dateString',
    },
    eval: function (value) {
        var ts = Date.parse("" + value);
        if (ts % 1 !== 0) {
            return { err: { code: 'type.dateString.not_valid', value: value, message: 'Not a valid date.' } };
        }
        return { err: null, value: new Date(ts) };
    },
};
/**
 * This constraint is copied from the customer-service, here: https://github.com/GrandVisionHQ/customer-service/blob/edd52993ff3b36fdb7472dd0eb4441fd31c41777/src/interface/models.ts#L21-L23
 * Explanation of regex: https://stackoverflow.com/questions/46155/how-to-validate-an-email-address-in-javascript
 */
Constraint.string.regex(/^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/);

var addressSpec$2 = Type.map(Type.string, Type.string);
var baseAddressContainer = {
    isPreferredBillingAddress: optional(Type.boolean),
    isPreferredShippingAddress: optional(Type.boolean),
    address: addressSpec$2,
};
var addressContainerSpec$1 = Type.interface(__assign(__assign({}, baseAddressContainer), { id: Type.string, createdAt: optional(isoDateSpec), updatedAt: optional(isoDateSpec) }));
Type.interface(baseAddressContainer);
var addressListSpec$1 = Type.array(addressContainerSpec$1);
var addressListResponse = addressListSpec$1;

var create$4 = function (apiUrl, _a) {
    var customerId = _a.customerId, accessToken = _a.accessToken, addressContainer = _a.addressContainer;
    return __awaiter(void 0, void 0, void 0, function () {
        var _b, _c;
        return __generator(this, function (_d) {
            switch (_d.label) {
                case 0:
                    _b = validateResponse;
                    _c = [addressListResponse];
                    return [4 /*yield*/, fetch(apiUrl + "/address-book/" + encodeURIComponent(customerId) + "/addresses", {
                            method: 'POST',
                            headers: __assign(__assign({}, postJson), authHeader(accessToken)),
                            body: JSON.stringify(addressContainer),
                        })];
                case 1: return [2 /*return*/, _b.apply(void 0, _c.concat([_d.sent()]))];
            }
        });
    });
};

var list$6 = function (apiUrl, _a) {
    var customerId = _a.customerId, accessToken = _a.accessToken;
    return __awaiter(void 0, void 0, void 0, function () {
        var _b, _c;
        return __generator(this, function (_d) {
            switch (_d.label) {
                case 0:
                    _b = validateResponse;
                    _c = [addressListResponse];
                    return [4 /*yield*/, fetch(apiUrl + "/address-book/" + encodeURIComponent(customerId) + "/addresses", {
                            method: 'GET',
                            headers: __assign(__assign({}, acceptJson), authHeader(accessToken)),
                        })];
                case 1: return [2 /*return*/, _b.apply(void 0, _c.concat([_d.sent()]))];
            }
        });
    });
};

var index$g = /*#__PURE__*/Object.freeze({
    __proto__: null,
    Types: types$7,
    create: create$4,
    list: list$6
});

var typename = function () {
    var names = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        names[_i] = arguments[_i];
    }
    return optional(Type.literal(names.reduce(function (acc, name) {
        var _a;
        return (__assign(__assign({}, acc), (_a = {}, _a[name] = 1, _a)));
    }, {})));
};
var localizedString = Type.map(Type.string, Type.string);
var durationSchema = {
    __typename: typename('Duration'),
    amount: Type.number,
    unit: Type.literal({ MINUTES: 1, HOURS: 1 }),
};
var priceSchema = {
    __typename: typename('Price'),
    amount: Type.number,
    currency: Type.string,
};
var appointmentTypeSchema = {
    __typename: typename('AppointmentType'),
    customerRequired: Type.boolean,
    duration: Type.interface(durationSchema),
    id: Type.string,
    label: Type.string,
    name: Type.string,
    additionalTags: optional(Type.map(Type.string, Type.string)),
    opticianRequired: Type.boolean,
    price: either(Type.null, Type.interface(priceSchema)),
    tryInStore: Type.boolean,
    visibleToCustomers: Type.boolean,
};
var appointmentSchema = {
    __typename: typename('Appointment'),
    id: Type.string,
    status: Type.string,
    startTime: Type.string,
    endTime: Type.string,
    appointmentType: Type.interface({
        __typename: typename('AppointmentType'),
        id: Type.string,
        name: Type.string,
        duration: Type.interface(durationSchema),
    }),
    store: Type.interface({
        __typename: typename('Store', 'AppointmentStore'),
        id: Type.string,
        code: Type.string,
        name: Type.string,
    }),
};
var matrixValue = either(Type.number, Type.string, Type.boolean, Type.null);
var matrixDependency = Type.map(Type.string, optional(Type.array(matrixValue)));
var matrixOption = Type.interface({
    __typename: typename('Option'),
    value: matrixValue,
    label: localizedString,
    description: either(localizedString, Type.null),
    tooltipKey: optional(either(Type.string, Type.null)),
    default: either(Type.boolean, Type.null),
});
var matrixSchema = {
    __typename: typename('TypesMatrix'),
    properties: Type.array(Type.interface({
        __typename: typename('Property'),
        name: Type.string,
        parents: Type.array(Type.string),
        showWhen: Type.array(matrixDependency),
        requiredWhen: Type.array(matrixDependency),
        title: localizedString,
        description: localizedString,
        options: Type.array(matrixOption),
        optional: either(Type.boolean, Type.null),
        renderInECommerceAs: either(Type.string, Type.null),
    })),
};
var timeSlotResponseSchema = {
    __typename: typename('TimeSlot'),
    from: Type.string,
    until: Type.string,
};
var appointmentResponseSpec = Type.interface(appointmentSchema);
var appointmentListResponseSpec = Type.array(appointmentResponseSpec);
var appointmentTypeResponseSpec = Type.interface(appointmentTypeSchema);
var appointmentTypesResponseSpec = Type.array(Type.interface(appointmentTypeSchema));
var appointmentTypesMatrixResponseSpec = Type.interface(matrixSchema);
var timeSlotsResponseSpec = Type.array(Type.interface(timeSlotResponseSchema));
var availabilityResponseSpec = Type.array(Type.interface({
    __typename: typename('Availability'),
    percentageAvailable: Type.number,
    slotsAvailable: Type.number,
    storeCode: Type.string,
    perDay: Type.map(Type.string, Type.interface({
        slotsAvailable: Type.number,
        percentageAvailable: Type.number,
    })),
}));
Type.interface({
    data: Type.interface({
        createCustomer: Type.interface({
            id: Type.string,
        }),
    }),
});
var createAppointmentResponseSpec = Type.interface({
    __typename: typename('Appointment'),
    id: Type.string,
    startTime: Type.string,
    endTime: Type.string,
    status: Type.string,
    createdBy: either(Type.string, Type.null),
    customerComment: either(Type.string, Type.null),
    bookingChannel: either(Type.string, Type.null),
    store: Type.interface({
        __typename: typename('Store', 'AppointmentStore'),
        id: Type.string,
        code: Type.string,
        name: Type.string,
        phone: either(Type.string, Type.null),
        address: Type.interface({
            __typename: typename('StoreAddress', 'AppointmentStoreAddress'),
            country: Type.string,
            city: Type.string,
            postalCode: Type.string,
            line1: either(Type.string, Type.null),
            line2: either(Type.string, Type.null),
        }),
        timeZone: either(Type.string, Type.null),
        url: either(Type.string, Type.null),
    }),
    additionalTags: optional(either(Type.map(Type.string, either(Type.boolean, Type.string)), Type.null)),
});

function availabilityByGeoLocation(apiUrl, query) {
    return __awaiter(this, void 0, void 0, function () {
        var filterNullable, _a, _b;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    filterNullable = omitBy(query, isNil);
                    _a = validateResponse;
                    _b = [availabilityResponseSpec];
                    return [4 /*yield*/, fetch(apiUrl + "/appointments/api/v1/availability" + (query ? QueryString.stringify(filterNullable) : ''), {
                            method: 'GET',
                            headers: __assign({}, acceptJson),
                        })];
                case 1: return [2 /*return*/, _a.apply(void 0, _b.concat([_c.sent()]))];
            }
        });
    });
}
function availabilityByStoreCode(apiUrl, query) {
    return __awaiter(this, void 0, void 0, function () {
        var filterNullable, _a, _b;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    filterNullable = omitBy(query, isNil);
                    _a = validateResponse;
                    _b = [availabilityResponseSpec];
                    return [4 /*yield*/, fetch(apiUrl + "/appointments/api/v1/availability" + (query ? QueryString.stringify(filterNullable) : ''), {
                            method: 'GET',
                            headers: __assign({}, acceptJson),
                        })];
                case 1: return [2 /*return*/, _a.apply(void 0, _b.concat([_c.sent()]))];
            }
        });
    });
}
/**
 * @deprecated Use availabilityByGeoLocation instead
 */
var availability = availabilityByGeoLocation;

function type(apiUrl, typeId, locale) {
    return __awaiter(this, void 0, void 0, function () {
        var _a, _b;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    _a = validateResponse;
                    _b = [appointmentTypeResponseSpec];
                    return [4 /*yield*/, fetch(apiUrl + "/appointments/api/v1/appointment-types/" + typeId, {
                            method: 'GET',
                            headers: __assign(__assign({}, acceptLanguageHeader(locale)), acceptJson),
                        })];
                case 1: return [2 /*return*/, _a.apply(void 0, _b.concat([_c.sent()]))];
            }
        });
    });
}
function types$6(apiUrl, query, locale) {
    return __awaiter(this, void 0, void 0, function () {
        var _a, _b;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    _a = validateResponse;
                    _b = [appointmentTypesResponseSpec];
                    return [4 /*yield*/, fetch(apiUrl + "/appointments/api/v1/appointment-types" + (query ? QueryString.stringify(query) : ''), {
                            method: 'GET',
                            headers: __assign(__assign({}, acceptLanguageHeader(locale)), acceptJson),
                        })];
                case 1: return [2 /*return*/, _a.apply(void 0, _b.concat([_c.sent()]))];
            }
        });
    });
}

function typesMatrix(apiUrl) {
    return __awaiter(this, void 0, void 0, function () {
        var _a, _b;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    _a = validateResponse;
                    _b = [appointmentTypesMatrixResponseSpec];
                    return [4 /*yield*/, fetch(apiUrl + "/appointments/api/v1/appointment-types-matrix", {
                            method: 'GET',
                            headers: __assign({}, acceptJson),
                        })];
                case 1: return [2 /*return*/, _a.apply(void 0, _b.concat([_c.sent()]))];
            }
        });
    });
}

function create$3(apiUrl, request, accessToken) {
    return __awaiter(this, void 0, void 0, function () {
        var _a, _b;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    _a = validateResponse;
                    _b = [createAppointmentResponseSpec];
                    return [4 /*yield*/, fetch(apiUrl + "/appointments/api/v1/appointments", {
                            method: 'POST',
                            headers: __assign(__assign(__assign({}, acceptJson), postJson), (accessToken ? authHeader(accessToken) : {})),
                            body: JSON.stringify(request),
                        })];
                case 1: return [2 /*return*/, _a.apply(void 0, _b.concat([_c.sent()]))];
            }
        });
    });
}

function get(apiUrl, appointmentId, accessToken) {
    return __awaiter(this, void 0, void 0, function () {
        var _a, _b;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    _a = validateResponse;
                    _b = [appointmentResponseSpec];
                    return [4 /*yield*/, fetch(apiUrl + "/appointments/api/v1/appointments/" + appointmentId, {
                            method: 'GET',
                            headers: __assign(__assign({}, acceptJson), authHeader(accessToken)),
                        })];
                case 1: return [2 /*return*/, _a.apply(void 0, _b.concat([_c.sent()]))];
            }
        });
    });
}

function cancel(apiUrl, appointmentId, accessToken, request) {
    return __awaiter(this, void 0, void 0, function () {
        var _a, _b;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    _a = validateResponse;
                    _b = [appointmentResponseSpec];
                    return [4 /*yield*/, fetch(apiUrl + "/appointments/api/v1/appointments/" + appointmentId, __assign({ method: 'DELETE', headers: __assign(__assign({}, acceptJson), authHeader(accessToken)) }, (request ? { body: JSON.stringify(request) } : {})))];
                case 1: return [2 /*return*/, _a.apply(void 0, _b.concat([_c.sent()]))];
            }
        });
    });
}

function list$5(apiUrl, accessToken, locale) {
    return __awaiter(this, void 0, void 0, function () {
        var _a, _b;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    _a = validateResponse;
                    _b = [appointmentListResponseSpec];
                    return [4 /*yield*/, fetch(apiUrl + "/appointments/api/v1/appointments", {
                            method: 'GET',
                            headers: __assign(__assign(__assign({}, acceptLanguageHeader(locale)), acceptJson), authHeader(accessToken)),
                        })];
                case 1: return [2 /*return*/, _a.apply(void 0, _b.concat([_c.sent()]))];
            }
        });
    });
}

function timeSlots(apiUrl, request) {
    return __awaiter(this, void 0, void 0, function () {
        var _a, _b;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    _a = validateResponse;
                    _b = [timeSlotsResponseSpec];
                    return [4 /*yield*/, fetch(apiUrl + "/appointments/api/v1/time-slots", {
                            method: 'POST',
                            headers: __assign(__assign({}, acceptJson), postJson),
                            body: JSON.stringify(request),
                        })];
                case 1: return [2 /*return*/, _a.apply(void 0, _b.concat([_c.sent()]))];
            }
        });
    });
}
function timeSlotsForStores(apiUrl, request) {
    return __awaiter(this, void 0, void 0, function () {
        var storeCodes, rest;
        return __generator(this, function (_a) {
            storeCodes = request.storeCodes, rest = __rest(request, ["storeCodes"]);
            return [2 /*return*/, Promise.all(storeCodes.map(function (storeCode) {
                    return timeSlots(apiUrl, __assign({ storeCode: storeCode }, rest));
                }))];
        });
    });
}

var unlink$1 = function (apiUrl, request) { return __awaiter(void 0, void 0, void 0, function () {
    var appointmentId, appointmentToken, response;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                appointmentId = request.appointmentId, appointmentToken = request.appointmentToken;
                return [4 /*yield*/, fetch(apiUrl + "/appointments/api/v1/appointments/" + appointmentId + "/customer?appointmentDataToken=" + appointmentToken, {
                        method: 'DELETE',
                        headers: __assign({}, acceptJson),
                    })];
            case 1:
                response = _a.sent();
                okOrThrow(response);
                return [2 /*return*/, response];
        }
    });
}); };

var index$f = /*#__PURE__*/Object.freeze({
    __proto__: null,
    availabilityByGeoLocation: availabilityByGeoLocation,
    availabilityByStoreCode: availabilityByStoreCode,
    availability: availability,
    type: type,
    types: types$6,
    typesMatrix: typesMatrix,
    create: create$3,
    get: get,
    cancel: cancel,
    list: list$5,
    timeSlots: timeSlots,
    timeSlotsForStores: timeSlotsForStores,
    unlink: unlink$1
});

var unwrapCartResponse = function (response) { return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (!response.ok) return [3 /*break*/, 2];
                return [4 /*yield*/, response.json()];
            case 1: return [2 /*return*/, (_a.sent())];
            case 2:
                if (response.status < 500) {
                    return [2 /*return*/, response.json().then(function (error) {
                            throw error;
                        })];
                }
                throw new Error("Got non OK response from server; " + response.status + " " + response.statusText);
        }
    });
}); };
var defaultCartExpands = [
    'shippingInfo.discountedPrice.includedDiscounts[*].discount',
    'lineItems[*].discountedPrice.includedDiscounts[*].discount',
    'lineItems[*].price.discounted.discount',
    'discountCodes[*].discountCode',
    'lineItems[*].variant.attributes[*].value',
];
var cartExpansionParam = "expand=" + encodeURIComponent(defaultCartExpands.join('|'));

var getCart = function (apiUrl, request) { return __awaiter(void 0, void 0, void 0, function () {
    var _a;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0:
                _a = unwrapCartResponse;
                return [4 /*yield*/, fetch(apiUrl + "/" + request.cartId + "?" + cartExpansionParam, {
                        method: 'GET',
                        headers: __assign({}, acceptJson),
                    })];
            case 1: return [2 /*return*/, _a.apply(void 0, [_b.sent()])];
        }
    });
}); };
var createCart = function (apiUrl, request) { return __awaiter(void 0, void 0, void 0, function () {
    var _a;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0:
                _a = unwrapCartResponse;
                return [4 /*yield*/, fetch(apiUrl + "/", {
                        method: 'POST',
                        headers: __assign(__assign({}, acceptJson), postJson),
                        body: JSON.stringify(request.cartDraft),
                    })];
            case 1: return [2 /*return*/, _a.apply(void 0, [_b.sent()])];
        }
    });
}); };
var updateCart = function (apiUrl, request) { return __awaiter(void 0, void 0, void 0, function () {
    var _a;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0:
                _a = unwrapCartResponse;
                return [4 /*yield*/, fetch(apiUrl + "/" + request.cartId + "/update?" + cartExpansionParam, {
                        method: 'POST',
                        headers: __assign(__assign({}, acceptJson), postJson),
                        body: JSON.stringify({
                            cartVersion: request.cartVersion,
                            actions: request.actions,
                        }),
                    })];
            case 1: return [2 /*return*/, _a.apply(void 0, [_b.sent()])];
        }
    });
}); };
var replicateCart = function (apiUrl, request) { return __awaiter(void 0, void 0, void 0, function () {
    var _a;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0:
                _a = unwrapCartResponse;
                return [4 /*yield*/, fetch(apiUrl + "/replicate", {
                        method: 'POST',
                        headers: __assign(__assign({}, acceptJson), postJson),
                        body: JSON.stringify({ reference: request.reference }),
                    })];
            case 1: return [2 /*return*/, _a.apply(void 0, [_b.sent()])];
        }
    });
}); };

var getShippingMethods = function (apiUrl, request) { return __awaiter(void 0, void 0, void 0, function () {
    var _a;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0:
                _a = unwrapResponse;
                return [4 /*yield*/, fetch(apiUrl + "/" + request.cartId + "/shippingMethods", {
                        method: 'GET',
                        headers: __assign({}, acceptJson),
                    })];
            case 1: return [2 /*return*/, _a.apply(void 0, [_b.sent()])];
        }
    });
}); };

var setLineItemQuantity = function (apiUrl, request) { return __awaiter(void 0, void 0, void 0, function () {
    var cartVersion, cartId, lineItemId, lineItemQuantity, _a;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0:
                cartVersion = request.cartVersion, cartId = request.cartId, lineItemId = request.lineItemId, lineItemQuantity = request.lineItemQuantity;
                _a = unwrapCartResponse;
                return [4 /*yield*/, fetch(apiUrl + "/" + cartId + "/" + lineItemId + "/quantity?" + cartExpansionParam, {
                        method: 'POST',
                        headers: __assign(__assign({}, acceptJson), postJson),
                        body: JSON.stringify({
                            cartVersion: cartVersion,
                            lineItemQuantity: lineItemQuantity,
                        }),
                    })];
            case 1: return [2 /*return*/, _a.apply(void 0, [_b.sent()])];
        }
    });
}); };
var setCustomLineItemQuantity = function (apiUrl, request) { return __awaiter(void 0, void 0, void 0, function () {
    var cartVersion, cartId, lineItemId, lineItemQuantity, _a;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0:
                cartVersion = request.cartVersion, cartId = request.cartId, lineItemId = request.lineItemId, lineItemQuantity = request.lineItemQuantity;
                _a = unwrapCartResponse;
                return [4 /*yield*/, fetch(apiUrl + "/" + cartId + "/update?" + cartExpansionParam, {
                        method: 'POST',
                        headers: __assign(__assign({}, acceptJson), postJson),
                        body: JSON.stringify({
                            cartVersion: cartVersion,
                            actions: [
                                {
                                    action: 'changeCustomLineItemQuantity',
                                    customLineItemId: lineItemId,
                                    quantity: lineItemQuantity,
                                },
                            ],
                        }),
                    })];
            case 1: return [2 /*return*/, _a.apply(void 0, [_b.sent()])];
        }
    });
}); };
var addLineItem = function (apiUrl, request) { return __awaiter(void 0, void 0, void 0, function () {
    var cartId, cartVersion, lineItemDraft, _a;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0:
                cartId = request.cartId, cartVersion = request.cartVersion, lineItemDraft = request.lineItemDraft;
                _a = unwrapCartResponse;
                return [4 /*yield*/, fetch(apiUrl + "/" + cartId + "/lineItems?" + cartExpansionParam, {
                        method: 'POST',
                        headers: __assign(__assign({}, acceptJson), postJson),
                        body: JSON.stringify(__assign({ cartVersion: cartVersion }, lineItemDraft)),
                    })];
            case 1: return [2 /*return*/, _a.apply(void 0, [_b.sent()])];
        }
    });
}); };

/**
 * These are error codes that can be returned by the cart service on any cart create/update call.
 * These errors will have corresponding labels in Bloomreach that can be used to notify the user about the type of error that occurred.
 */
var ValidationErrorCode;
(function (ValidationErrorCode) {
    ValidationErrorCode["ContainsMutuallyExclusiveProductTypes"] = "ContainsMutuallyExclusiveProductTypes";
    ValidationErrorCode["MaxQuantitySkuExceeded"] = "MaxQuantitySkuExceeded";
    ValidationErrorCode["MaxMasterVariantQuantityExceeded"] = "MaxMasterVariantQuantityExceeded";
    ValidationErrorCode["MaxVariantsPerProductTypeQuantityExceeded"] = "MaxVariantsPerProductTypeQuantityExceeded";
    ValidationErrorCode["QuantityExceededPrescriptionExpiryDate"] = "QuantityExceededPrescriptionExpiryDate";
    ValidationErrorCode["UnavailableProductsInCart"] = "UnavailableProductsInCart";
    ValidationErrorCode["PrescriptionGlassesInvalidBundleCombination"] = "PrescriptionGlassesInvalidBundleCombination";
    ValidationErrorCode["PrescriptionGlassesInvalidOpticalParameters"] = "PrescriptionGlassesInvalidOpticalParameters";
})(ValidationErrorCode || (ValidationErrorCode = {}));

var index$e = /*#__PURE__*/Object.freeze({
    __proto__: null,
    getCart: getCart,
    createCart: createCart,
    updateCart: updateCart,
    replicateCart: replicateCart,
    getShippingMethods: getShippingMethods,
    setLineItemQuantity: setLineItemQuantity,
    setCustomLineItemQuantity: setCustomLineItemQuantity,
    addLineItem: addLineItem,
    get ValidationErrorCode () { return ValidationErrorCode; }
});

var addressSpec$1 = {
    key: optional(Type.string),
    title: optional(Type.string),
    salutation: optional(Type.string),
    firstName: Type.string,
    middleName: optional(Type.string),
    affixLastName: optional(Type.string),
    lastName: Type.string,
    streetName: Type.string,
    streetNumber: optional(Type.string),
    additionalStreetInfo: optional(Type.string),
    additionalAddressInfo: optional(Type.string),
    postalCode: optional(Type.string),
    city: optional(Type.string),
    county: optional(Type.string),
    region: optional(Type.string),
    state: optional(Type.string),
    country: optional(Type.string),
    company: optional(Type.string),
    department: optional(Type.string),
    building: optional(Type.string),
    apartment: optional(Type.string),
    pOBox: optional(Type.string),
    phone: optional(Type.string),
    mobile: optional(Type.string),
    email: optional(Type.string),
    externalId: optional(Type.string),
    addressTypes: Type.array(Type.literal({
        billing: 1,
        delivery: 1,
        subscription: 1,
        'billing-online': 1,
        'delivery-online': 1,
        'billing-subscription': 1,
        'delivery-subscription': 1,
    })),
};
Type.interface(addressSpec$1);
var addressContainerSpec = Type.interface(__assign(__assign({}, addressSpec$1), { id: Type.string, createdAt: optional(isoDateSpec), updatedAt: optional(isoDateSpec) }));
var addressListSpec = Type.array(addressContainerSpec);

var create$2 = function (apiUrl, _a) {
    var customerId = _a.customerId, accessToken = _a.accessToken, address = _a.address;
    return __awaiter(void 0, void 0, void 0, function () {
        var _b, _c;
        return __generator(this, function (_d) {
            switch (_d.label) {
                case 0:
                    _b = validateResponse;
                    _c = [addressContainerSpec];
                    return [4 /*yield*/, fetch(apiUrl + "/customers/customers/" + encodeURIComponent(customerId) + "/addresses", {
                            method: 'POST',
                            headers: __assign(__assign(__assign({}, acceptJson), postJson), authHeader(accessToken)),
                            body: JSON.stringify(address),
                        })];
                case 1: return [2 /*return*/, _b.apply(void 0, _c.concat([_d.sent()]))];
            }
        });
    });
};

var list$4 = function (apiUrl, _a) {
    var customerId = _a.customerId, accessToken = _a.accessToken;
    return __awaiter(void 0, void 0, void 0, function () {
        var _b, _c;
        return __generator(this, function (_d) {
            switch (_d.label) {
                case 0:
                    _b = validateResponse;
                    _c = [addressListSpec];
                    return [4 /*yield*/, fetch(apiUrl + "/customers/customers/" + encodeURIComponent(customerId) + "/addresses", {
                            method: 'GET',
                            headers: __assign(__assign({}, acceptJson), authHeader(accessToken)),
                        })];
                case 1: return [2 /*return*/, _b.apply(void 0, _c.concat([_d.sent()]))];
            }
        });
    });
};

var deleteAddress = function (apiUrl, _a) {
    var customerId = _a.customerId, accessToken = _a.accessToken, addressId = _a.addressId;
    return __awaiter(void 0, void 0, void 0, function () {
        var _b;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    _b = unwrapResponse;
                    return [4 /*yield*/, fetch(apiUrl + "/customers/customers/" + encodeURIComponent(customerId) + "/addresses/" + addressId, {
                            method: 'DELETE',
                            headers: __assign(__assign({}, acceptJson), authHeader(accessToken)),
                        })];
                case 1: return [2 /*return*/, _b.apply(void 0, [_c.sent()])];
            }
        });
    });
};

var edit = function (apiUrl, _a) {
    var customerId = _a.customerId, accessToken = _a.accessToken, address = _a.address, id = _a.id;
    return __awaiter(void 0, void 0, void 0, function () {
        var _b;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    _b = unwrapResponse;
                    return [4 /*yield*/, fetch(apiUrl + "/customers/customers/" + encodeURIComponent(customerId) + "/addresses/" + id, {
                            method: 'PUT',
                            headers: __assign(__assign(__assign({}, acceptJson), postJson), authHeader(accessToken)),
                            body: JSON.stringify(address),
                        })];
                case 1: return [2 /*return*/, _b.apply(void 0, [_c.sent()])];
            }
        });
    });
};

var index$d = /*#__PURE__*/Object.freeze({
    __proto__: null,
    create: create$2,
    list: list$4,
    deleteAddress: deleteAddress,
    edit: edit
});

function changePassword(apiUrl, accessToken, customerId, request) {
    return __awaiter(this, void 0, void 0, function () {
        var _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    _a = unwrapResponse;
                    return [4 /*yield*/, fetch(apiUrl + "/customers/account/password/" + encodeURIComponent(customerId) + "/change", {
                            method: 'POST',
                            headers: __assign(__assign(__assign({}, acceptJson), postJson), authHeader(accessToken)),
                            body: JSON.stringify(request),
                        })];
                case 1: return [2 /*return*/, _a.apply(void 0, [_b.sent()])];
            }
        });
    });
}

function resetPassword(apiUrl, request) {
    return __awaiter(this, void 0, void 0, function () {
        var _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    _a = unwrapResponse;
                    return [4 /*yield*/, fetch(apiUrl + "/customers/account/password/reset", {
                            method: 'POST',
                            headers: __assign(__assign({}, acceptJson), postJson),
                            body: JSON.stringify(request),
                        })];
                case 1: return [2 /*return*/, _a.apply(void 0, [_b.sent()])];
            }
        });
    });
}

var index$c = /*#__PURE__*/Object.freeze({
    __proto__: null,
    changePassword: changePassword,
    resetPassword: resetPassword
});

var types$5 = /*#__PURE__*/Object.freeze({
    __proto__: null
});

var prescriptionContentSpec = Type.interface({
    power: Type.string,
    baseCurve: Type.string,
    diameter: Type.string,
    cylinder: optional(Type.string),
    axis: optional(Type.string),
    addition: optional(Type.string),
    productId: optional(Type.string),
});
var prescriptionSpec = Type.interface({
    id: Type.string,
    name: Type.string,
    issueDate: isoDateSpec,
    expiryDate: isoDateSpec,
    storeName: Type.string,
    storeId: optional(Type.string),
    recommendedNextEyeTestDate: optional(isoDateSpec),
    validityStatus: Type.literal({
        VALID: 1,
        INVALID: 1,
    }),
    leftEye: prescriptionContentSpec,
    rightEye: prescriptionContentSpec,
});
var prescriptionsListSpec = Type.array(prescriptionSpec);

function list$3(apiUrl, accessToken, request) {
    return __awaiter(this, void 0, void 0, function () {
        var _a, _b;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    _a = validateResponse;
                    _b = [prescriptionsListSpec];
                    return [4 /*yield*/, fetch(apiUrl + "/customers/customer/" + encodeURIComponent(request.customerId) + "/prescriptions", {
                            method: 'GET',
                            headers: __assign(__assign({}, acceptJson), authHeader(accessToken)),
                        })];
                case 1: return [2 /*return*/, _a.apply(void 0, _b.concat([_c.sent()]))];
            }
        });
    });
}

var types$4 = /*#__PURE__*/Object.freeze({
    __proto__: null
});

function signedPrescriptions(apiUrl, accessToken, request) {
    return __awaiter(this, void 0, void 0, function () {
        var _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    _a = unwrapResponse;
                    return [4 /*yield*/, fetch(apiUrl + "/customers/customer/" + encodeURIComponent(request.customerId) + "/signedprescriptions", {
                            method: 'GET',
                            headers: __assign(__assign({}, acceptJson), authHeader(accessToken)),
                        })];
                case 1: return [2 /*return*/, _a.apply(void 0, [_b.sent()])];
            }
        });
    });
}

var index$b = /*#__PURE__*/Object.freeze({
    __proto__: null,
    list: list$3,
    signedPrescriptions: signedPrescriptions
});

var currencySpec = Type.literal({ EUR: 1, GBP: 1 });
var moneySpec = Type.interface({
    amount: positiveIntegerSpec,
    currency: currencySpec,
    precision: integerAbove0$1,
});
var deliverySpec = Type.interface({
    reference: optional(Type.string),
    date: isoDateSpec,
    boxesPerEyeSide: optional(positiveIntegerSpec),
    status: Type.literal({
        PENDING: 1,
        READY: 1,
        SHIPPED: 1,
        DELIVERED: 1,
    }),
});
var lineItemSpec = Type.interface({
    productId: Type.string,
    quantity: integerAbove0$1,
    application: Type.array(Type.literal({ LEFT_EYE: 1, RIGHT_EYE: 1 })),
});
var paymentMethodSpec = Type.interface({
    type: Type.string,
    details: Type.map(Type.string, Type.string),
});
var pauseOptionSpec = Type.interface({
    amount: integerSpec,
    unit: Type.literal({
        MONTHS: 1,
    }),
});
var subscriptionSpec = Type.interface({
    id: Type.string,
    expiryDate: isoDateSpec,
    status: Type.literal({
        ACTIVE: 1,
        PAUSED: 1,
        EXPIRED: 1,
        CANCELLED: 1,
        ON_HOLD: 1,
        PENDING: 1,
    }),
    pendingChanges: Type.array(Type.literal({
        pause: 1,
        quantity: 1,
    })),
    pauseOptions: Type.array(pauseOptionSpec),
    billing: Type.interface({
        totalPricePerInstallment: moneySpec,
    }),
    deliveries: Type.array(deliverySpec),
    deliveryFrequency: optional(Type.literal({
        WEEKLY: 1,
        BI_WEEKLY: 1,
        MONTHLY: 1,
        QUARTERLY: 1,
        ANNUALLY: 1,
    })),
    deliveryAddress: Type.map(Type.string, Type.string),
    billingAddress: optional(Type.map(Type.string, Type.string)),
    lineItems: Type.array(lineItemSpec),
    paymentMethod: paymentMethodSpec,
    topUpAllowed: Type.boolean,
    quantityChangeable: Type.boolean,
    installments: Type.array(Type.interface({
        date: isoDateSpec,
        totalPrice: moneySpec,
        paymentMethod: Type.string,
        status: Type.literal({
            PAID: 1,
            PENDING: 1,
            CANCELLED: 1,
            FAILED: 1,
            PLANNED: 1,
        }),
    })),
    custom: optional(Type.map(Type.string, Type.unknown)),
});
var subscriptionListItemSpec = Type.interface({
    id: Type.string,
});
var subscriptionList = Type.array(subscriptionListItemSpec);
var subscriptionListResponse = Type.interface({
    subscriptions: subscriptionList,
});

function details$2(apiUrl, accessToken, request) {
    return __awaiter(this, void 0, void 0, function () {
        var _a, _b;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    _a = validateResponse;
                    _b = [subscriptionSpec];
                    return [4 /*yield*/, fetch(apiUrl + "/customers/customer/" + encodeURIComponent(request.customerId) + "/subscription/" + request.subscriptionId, {
                            method: 'GET',
                            headers: __assign(__assign({}, acceptJson), authHeader(accessToken)),
                        })];
                case 1: return [2 /*return*/, _a.apply(void 0, _b.concat([_c.sent()]))];
            }
        });
    });
}

function pause(apiUrl, accessToken, customerId, subscriptionId, request) {
    return __awaiter(this, void 0, void 0, function () {
        var _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    _a = okOrThrow;
                    return [4 /*yield*/, fetch(apiUrl + "/customers/customer/" + encodeURIComponent(customerId) + "/subscription/" + subscriptionId + "/pause", {
                            method: 'POST',
                            headers: __assign(__assign(__assign({}, acceptJson), postJson), authHeader(accessToken)),
                            body: JSON.stringify(request),
                        })];
                case 1: return [2 /*return*/, _a.apply(void 0, [_b.sent()])];
            }
        });
    });
}

function quantity(apiUrl, accessToken, customerId, subscriptionId, request) {
    return __awaiter(this, void 0, void 0, function () {
        var _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    _a = unwrapResponse;
                    return [4 /*yield*/, fetch(apiUrl + "/customers/customer/" + encodeURIComponent(customerId) + "/subscription/" + subscriptionId + "/quantity", {
                            method: 'POST',
                            headers: __assign(__assign(__assign({}, acceptJson), postJson), authHeader(accessToken)),
                            body: JSON.stringify(request),
                        })];
                case 1: return [2 /*return*/, _a.apply(void 0, [_b.sent()])];
            }
        });
    });
}

var types$3 = /*#__PURE__*/Object.freeze({
    __proto__: null
});

var list$2 = function (apiUrl, _a) {
    var customerId = _a.customerId, accessToken = _a.accessToken;
    return __awaiter(void 0, void 0, void 0, function () {
        var _b, _c;
        return __generator(this, function (_d) {
            switch (_d.label) {
                case 0:
                    _b = validateResponse;
                    _c = [subscriptionListResponse];
                    return [4 /*yield*/, fetch(apiUrl + "/customers/customer/" + encodeURIComponent(customerId) + "/subscriptions", {
                            method: 'GET',
                            headers: __assign(__assign({}, acceptJson), authHeader(accessToken)),
                        })];
                case 1: return [2 /*return*/, _b.apply(void 0, _c.concat([_d.sent()]))];
            }
        });
    });
};

var index$a = /*#__PURE__*/Object.freeze({
    __proto__: null,
    details: details$2,
    pause: pause,
    quantity: quantity,
    list: list$2
});

function changeAddress(apiUrl, accessToken, customerId, request) {
    var _a;
    return __awaiter(this, void 0, void 0, function () {
        var _b;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    _b = unwrapResponse;
                    return [4 /*yield*/, fetch(apiUrl + "/customers/customer/" + encodeURIComponent(customerId) + "/addresses", {
                            method: 'PUT',
                            headers: __assign(__assign(__assign({}, acceptJson), postJson), authHeader(accessToken)),
                            body: JSON.stringify(__assign(__assign(__assign({}, request.fields), { addressTypes: request.addressTypes }), optionalKey('externalId', String((_a = request.externalId) !== null && _a !== void 0 ? _a : '')))),
                        })];
                case 1: return [2 /*return*/, _b.apply(void 0, [_c.sent()])];
            }
        });
    });
}

var personalDetailsSchema = {
    personalDetails: Type.map(Type.string, Type.unknown),
};
var personalDetailsResponseSpec = Type.interface(personalDetailsSchema);
Type.interface(personalDetailsSchema);
var createAccountResponseSpec = Type.interface({
    accountId: Type.string,
    accountDataToken: Type.string,
});

function create$1(apiUrl, request) {
    return __awaiter(this, void 0, void 0, function () {
        var _a, _b, personalDetails, _c, optins, loginRedirectUrl, emailAddress, optInsUpdate, additionalData, stateParams, body, _d, _e;
        return __generator(this, function (_f) {
            switch (_f.label) {
                case 0:
                    _a = request.additionalAccountData, _b = _a.personalDetails, personalDetails = _b === void 0 ? {} : _b, _c = _a.optins, optins = _c === void 0 ? {} : _c;
                    loginRedirectUrl = request.loginRedirectUrl, emailAddress = request.emailAddress;
                    optInsUpdate = Object.keys(optins).length > 0 ? optins : undefined;
                    additionalData = { personalDetails: personalDetails, optins: optInsUpdate };
                    stateParams = { targetAction: 'signUp' };
                    body = __assign({ loginRedirectUrl: loginRedirectUrl, emailAddress: emailAddress, state: JSON.stringify(stateParams) }, additionalData);
                    _d = validateResponse;
                    _e = [createAccountResponseSpec];
                    return [4 /*yield*/, fetch(apiUrl + "/customers/account/create", {
                            method: 'POST',
                            headers: __assign(__assign({}, acceptJson), postJson),
                            body: JSON.stringify(body),
                        })];
                case 1: return [2 /*return*/, _d.apply(void 0, _e.concat([_f.sent()]))];
            }
        });
    });
}

function details$1(apiUrl, accessToken, customerId) {
    return __awaiter(this, void 0, void 0, function () {
        var _a, _b;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    _a = validateResponse;
                    _b = [personalDetailsResponseSpec];
                    return [4 /*yield*/, fetch(apiUrl + "/customers/customer/" + encodeURIComponent(customerId) + "/details", {
                            method: 'GET',
                            headers: __assign(__assign({}, acceptJson), authHeader(accessToken)),
                        })];
                case 1: return [2 /*return*/, _a.apply(void 0, _b.concat([_c.sent()]))];
            }
        });
    });
}
function updateDetails(apiUrl, accessToken, customerId, request) {
    return __awaiter(this, void 0, void 0, function () {
        var _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    _a = unwrapResponse;
                    return [4 /*yield*/, fetch(apiUrl + "/customers/customer/" + encodeURIComponent(customerId) + "/details", {
                            method: 'POST',
                            headers: __assign(__assign(__assign({}, acceptJson), postJson), authHeader(accessToken)),
                            body: JSON.stringify(request),
                        })];
                case 1: return [2 /*return*/, _a.apply(void 0, [_b.sent()])];
            }
        });
    });
}

var FormName;
(function (FormName) {
    FormName["personalDetails"] = "personalDetails";
    FormName["billingAddress"] = "billingAddress";
    FormName["preferredStore"] = "preferredStore";
})(FormName || (FormName = {}));

var index$9 = /*#__PURE__*/Object.freeze({
    __proto__: null,
    Addresses: index$d,
    Password: index$c,
    Subscriptions: index$a,
    Prescriptions: index$b,
    PasswordTypes: types$5,
    SubscriptionsTypes: types$3,
    PrescriptionsTypes: types$4,
    changeAddress: changeAddress,
    create: create$1,
    details: details$1,
    updateDetails: updateDetails,
    get FormName () { return FormName; }
});

var placePredictionsResponseSpec = Type.interface({
    name: Type.string,
    places: Type.array(Type.array(Type.string)),
});
var placePredictionsExtendedResponseSpec = Type.interface({
    name: Type.string,
    places: Type.array(Type.interface({
        id: Type.string,
        address: Type.array(Type.string),
    })),
});
var placeDetailsResponseSpec = Type.interface({
    coordinates: Type.interface({
        lat: Type.number,
        lng: Type.number,
    }),
});
var coordinatesResponseSpec = Type.interface({
    address: Type.string,
    coordinates: Type.interface({
        lat: Type.number,
        lng: Type.number,
    }),
});

var getCoordinates = function (apiUrl, request) { return __awaiter(void 0, void 0, void 0, function () {
    var _a, _b;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0:
                _a = validateResponse;
                _b = [coordinatesResponseSpec];
                return [4 /*yield*/, fetch(apiUrl + "/address/coordinates?address=" + request.query, {
                        method: 'GET',
                        headers: __assign({}, acceptJson),
                    })];
            case 1: return [2 /*return*/, _a.apply(void 0, _b.concat([_c.sent()]))];
        }
    });
}); };

var getPlaceDetails = function (apiUrl, request) { return __awaiter(void 0, void 0, void 0, function () {
    var _a, _b;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0:
                _a = validateResponse;
                _b = [placeDetailsResponseSpec];
                return [4 /*yield*/, fetch(apiUrl + "/place/details?place_id=" + request.id, {
                        method: 'GET',
                        headers: __assign({}, acceptJson),
                    })];
            case 1: return [2 /*return*/, _a.apply(void 0, _b.concat([_c.sent()]))];
        }
    });
}); };

var getPlacePredictions = function (apiUrl, request) { return __awaiter(void 0, void 0, void 0, function () {
    var _a, _b;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0:
                _a = validateResponse;
                _b = [placePredictionsResponseSpec];
                return [4 /*yield*/, fetch(apiUrl + "/place/predictions?name=" + request.place, {
                        method: 'GET',
                        headers: __assign({}, acceptJson),
                    })];
            case 1: return [2 /*return*/, _a.apply(void 0, _b.concat([_c.sent()]))];
        }
    });
}); };

var getPlacePredictionsExtended = function (apiUrl, request) { return __awaiter(void 0, void 0, void 0, function () {
    var _a, _b;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0:
                _a = validateResponse;
                _b = [placePredictionsExtendedResponseSpec];
                return [4 /*yield*/, fetch(apiUrl + "/place/predictions/extended?name=" + request.place, {
                        method: 'GET',
                        headers: __assign({}, acceptJson),
                    })];
            case 1: return [2 /*return*/, _a.apply(void 0, _b.concat([_c.sent()]))];
        }
    });
}); };

var index$8 = /*#__PURE__*/Object.freeze({
    __proto__: null,
    getCoordinates: getCoordinates,
    getPlaceDetails: getPlaceDetails,
    getPlacePredictions: getPlacePredictions,
    getPlacePredictionsExtended: getPlacePredictionsExtended
});

function decide(apiUrl, request) {
    return __awaiter(this, void 0, void 0, function () {
        var experiment, userId, url, _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    experiment = request.experiment, userId = request.userId;
                    url = new URL("experiments/" + experiment, apiUrl);
                    _a = unwrapResponse;
                    return [4 /*yield*/, fetch(url.href, {
                            method: 'POST',
                            body: JSON.stringify({ userId: userId }),
                            headers: __assign(__assign({}, postJson), acceptJson),
                        })];
                case 1: return [2 /*return*/, _a.apply(void 0, [_b.sent(), { useResponseError: true }])];
            }
        });
    });
}

var index$7 = /*#__PURE__*/Object.freeze({
    __proto__: null,
    decide: decide
});

var create = function (apiUrl, request, accessToken) { return __awaiter(void 0, void 0, void 0, function () {
    var _a;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0:
                _a = unwrapResponse;
                return [4 /*yield*/, fetch(apiUrl, {
                        method: 'POST',
                        headers: __assign(__assign(__assign(__assign({}, acceptJson), postJson), (accessToken ? authHeader(accessToken) : {})), correlationHeader()),
                        body: JSON.stringify(request),
                    })];
            case 1: return [2 /*return*/, _a.apply(void 0, [_b.sent()])];
        }
    });
}); };
var createForCustomer = function (apiUrl, customerId, accessToken, request) { return __awaiter(void 0, void 0, void 0, function () {
    var _a;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0:
                _a = unwrapResponse;
                return [4 /*yield*/, fetch(apiUrl + "/customer/" + encodeURIComponent(customerId) + "/create", {
                        method: 'POST',
                        headers: __assign(__assign(__assign(__assign({}, acceptJson), postJson), authHeader(accessToken)), correlationHeader()),
                        body: JSON.stringify(request),
                    })];
            case 1: return [2 /*return*/, _a.apply(void 0, [_b.sent()])];
        }
    });
}); };

var integerAbove0 = constrain(integerSpec, [Constraint.number.above(0)]);
var localizedStringSpec$1 = adjust(Type.map(Type.string, Type.string), {
    skipInvalidValues: true,
});
var addressSpec = adjust(Type.map(Type.string, Type.string), {
    skipInvalidValues: true,
});
var money = Type.interface({
    currency: Type.string,
    amount: positiveIntegerSpec,
    precision: integerAbove0,
});
var mediaImages = Type.interface({
    url: Type.string,
    dimensions: Type.interface({
        w: Type.number,
        h: Type.number,
    }),
    label: optional(Type.string),
});
var productSchemaBase = {
    name: localizedStringSpec$1,
    sku: Type.string,
    imageId: optional(Type.string),
    media: optional(Type.interface({
        images: Type.array(mediaImages),
    })),
};
var attributesSchemaBase = {
    brand: Type.string,
    brandModel: optional(Type.string),
    brandModelCode: optional(Type.string),
    opcoBackendId: optional(Type.string),
    supplierEAN: optional(Type.string),
};
var contactLensAttributeTypes = either(Type.literal({
    'Contact-lenses': 1,
}), Type.literal({
    CONTACT_LENSES: 1,
}));
var contactLensBundleAttributeTypes = either(Type.literal({
    'Contact-lens-bundles': 1,
}), Type.literal({
    CONTACT_LENS_BUNDLES: 1,
}));
var contactLensesAttributesSchemaBase = {
    packageQuantity: positiveIntegerSpec,
    replacementFrequency: localizedStringSpec$1,
    eyeSide: optional(Type.literal({
        left: 1,
        right: 1,
        both: 1,
    })),
    isSubscription: optional(Type.boolean),
    // temporary property, needs be removed when LiquidPixel is replaced with Bynder
    sapArticleNumber: optional(Type.string),
};
var contactLensesProductSpec = Type.interface(__assign(__assign({ attributesType: contactLensAttributeTypes }, productSchemaBase), { attributes: Type.interface(contactLensesAttributesSchemaBase) }));
var contactLensesBundleAttributesSchemaBase = {
    lensType: localizedStringSpec$1,
    isSubscription: Type.boolean,
    months: positiveIntegerSpec,
    imageSku: optional(Type.string),
    fixedDiscount: optional(Type.number),
    leftLensAxis: optional(Type.number),
    leftLensBaseCurve: optional(Type.number),
    leftLensCylinder: optional(Type.number),
    leftLensDiameter: optional(Type.number),
    leftLensName: optional(Type.string),
    leftLensPower: optional(Type.number),
    leftLensSku: optional(Type.string),
    leftLensVariantSku: optional(Type.string),
    rightLensAxis: optional(Type.number),
    rightLensBaseCurve: optional(Type.number),
    rightLensCylinder: optional(Type.number),
    rightLensDiameter: optional(Type.number),
    rightLensName: optional(Type.string),
    rightLensPower: optional(Type.number),
    rightLensSku: optional(Type.string),
    rightLensVariantSku: optional(Type.string),
    solutionName: optional(Type.string),
    solutionSku: optional(Type.string),
    bundleProduct1Media: optional(Type.interface({
        images: Type.array(mediaImages),
    })),
    bundleProduct2Media: optional(Type.interface({
        images: Type.array(mediaImages),
    })),
    bundleProduct3Media: optional(Type.interface({
        images: Type.array(mediaImages),
    })),
};
var contactLensesBundleSpec = Type.interface(__assign(__assign({ attributesType: contactLensBundleAttributeTypes }, productSchemaBase), { attributes: Type.interface(contactLensesBundleAttributesSchemaBase) }));
/*
  The baseCurve, diameter and power parameters are temporarily made optional due to the issue
  with order-service. Needs to be reverted later
  See the issue: https://jira.grandvision.global/browse/MACC-3839
*/
var contactLensesProductDetailsSpec = Type.interface(__assign(__assign({ attributesType: contactLensAttributeTypes }, productSchemaBase), { attributes: Type.interface(__assign(__assign({}, contactLensesAttributesSchemaBase), { baseCurve: optional(Type.string), diameter: optional(Type.string), power: optional(Type.string), axis: optional(Type.string), cylinder: optional(Type.string), addition: optional(Type.string) })) }));
var solutionAttributeTypes = either(Type.literal({ Solutions: 1 }), Type.literal({ SOLUTIONS: 1 }));
var solutionProductSpec = Type.interface(__assign(__assign({ attributesType: solutionAttributeTypes }, productSchemaBase), { attributes: Type.interface({
        brand: attributesSchemaBase.brand,
        solutionType: Type.string,
        volume: positiveIntegerSpec,
        opcoBackendId: optional(Type.string),
    }) }));
var sunglassesAttributeTypes = either(Type.literal({ sunglasses: 1 }), Type.literal({ SUNGLASSES: 1 }));
var sunglassesSchema = __assign(__assign({ attributesType: sunglassesAttributeTypes }, productSchemaBase), { attributes: Type.interface(__assign({}, attributesSchemaBase)) });
var sunglassesProductSpec = Type.interface(sunglassesSchema);
var prescriptionGlassesAttributeTypes = either(Type.literal({ prescriptionGlasses: 1 }), Type.literal({ PRESCRIPTION_GLASSES: 1 }));
var Prescription = adjust(Type.map(Type.string, Type.number), {
    skipInvalidValues: true,
});
var PrescriptionGlassesMoney = Type.interface({
    currencyCode: Type.string,
    centAmount: Type.number,
    fractionDigits: Type.number,
    type: Type.string,
});
var readyReadersAttributeTypes = either(Type.literal({ readyReaders: 1 }), Type.literal({ READY_READERS: 1 }));
var readyReadersSchema = __assign(__assign({ attributesType: readyReadersAttributeTypes }, productSchemaBase), { attributes: Type.interface(__assign({}, attributesSchemaBase)) });
var readyReadersProductSpec = Type.interface(readyReadersSchema);
var BundlePrice = Type.interface({
    id: Type.string,
    value: PrescriptionGlassesMoney,
    discounted: optional(Type.interface({
        value: PrescriptionGlassesMoney,
    })),
});
var variant = Type.interface({
    sku: Type.string,
    media: optional(Type.interface({
        images: Type.array(mediaImages),
    })),
});
var prescriptionMetaDataSchema = {
    examDate: optional(isoDateSpec),
    expiryDate: optional(isoDateSpec),
    opticianDetails: optional(Type.string), // stringified JSON
};
var prescriptionDataSchema = __assign(__assign({}, prescriptionMetaDataSchema), { rightLens: optional(Prescription), leftLens: optional(Prescription) });
Type.interface(prescriptionDataSchema);
var existingCustomer = Type.interface({
    type: Type.literal({ ExistingCustomer: 1 }),
});
var newPrescription = Type.interface(__assign({ type: Type.literal({ NewPrescription: 1 }) }, prescriptionDataSchema));
var prescriptionFile = Type.interface({
    type: Type.literal({ PrescriptionFile: 1 }),
    fileName: Type.string,
    storageId: Type.string,
    pupillaryDistanceFileFileName: Type.string,
    pupillaryDistanceFileStorageId: Type.string,
});
var emailPrescription = Type.interface({
    type: Type.literal({ EmailPrescription: 1 }),
});
var bundleChildLineItemBase = {
    productId: Type.string,
    productType: Type.string,
    name: localizedStringSpec$1,
    price: BundlePrice,
};
var bundleMainLineItemBase = {
    price: BundlePrice,
    productType: Type.string,
    opcoBackendProductId: optional(Type.string),
};
var bundleChildLineItem = Type.interface(__assign(__assign({}, bundleChildLineItemBase), { variant: variant }));
var bundleMainLineItem = Type.interface(__assign(__assign({}, bundleMainLineItemBase), { variant: variant }));
var prescriptionGlassesProductSpec = Type.interface(__assign(__assign({}, sunglassesSchema), { attributesType: prescriptionGlassesAttributeTypes, lineItemDetail: Type.interface({
        bundleMainLineItem: bundleMainLineItem,
        bundleChildLineItems: Type.array(bundleChildLineItem),
        prescription: optional(either(existingCustomer, newPrescription, prescriptionFile, emailPrescription)),
    }) }));
var nonPrescriptionBundlesTypes = either(Type.literal({ nonPrescriptionBundle: 1 }), Type.literal({ NON_PRESCRIPTION_BUNDLE: 1 }));
var nonPrescriptionBundlesSchema = __assign(__assign({ attributesType: nonPrescriptionBundlesTypes }, productSchemaBase), { attributes: Type.interface({
        includesLenses: Type.boolean,
    }), lineItemDetail: Type.interface({
        bundleMainLineItem: Type.interface(bundleMainLineItemBase),
        bundleChildLineItems: Type.array(Type.interface(bundleChildLineItemBase)),
        configurationBundle: Type.interface(__assign(__assign({}, bundleChildLineItemBase), { isPrescriptionNeeded: Type.boolean, includesLenses: Type.boolean })),
    }) });
var nonPrescriptionBundleProductSpec = Type.interface(nonPrescriptionBundlesSchema);
var framesAttributeTypes = either(Type.literal({ frames: 1 }), Type.literal({ FRAMES: 1 }));
var framesProductSpec = Type.interface(__assign(__assign({ attributesType: framesAttributeTypes }, productSchemaBase), { attributes: Type.interface(__assign({}, attributesSchemaBase)) }));
var clsPriceSpec = Type.interface({
    discount: Type.interface({
        amount: Type.number,
        percentage: Type.number,
    }),
    net: Type.number,
    subtotal: Type.number,
    tax: Type.interface({
        amount: Type.number,
        portions: Type.array(Type.interface({
            rate: Type.number,
            amount: Type.number,
        })),
    }),
    gross: Type.number,
});
var contactLensSubscriptionItem = Type.interface({
    gan: Type.string,
    mediaImages: Type.array(mediaImages),
    name: Type.string,
    packageQuantity: optional(Type.number),
    quantity: Type.number,
    ratePlanId: Type.string,
    regularImages: Type.array(mediaImages),
    sku: Type.string,
    type: Type.literal({ SOLUTION: 1, LENS: 1 }),
    price: Type.interface({
        total: clsPriceSpec,
        unit: clsPriceSpec,
    }),
});
var lensPrescription = Type.interface({
    gan: Type.string,
    sku: Type.string,
    baseCurve: Type.number,
    diameter: Type.number,
    power: Type.number,
    axis: optional(Type.number),
    cylinder: optional(Type.number),
    addition: optional(Type.string),
});
var contactLensSubscriptionAttributeTypes = either(Type.literal({ contactLensSubscription: 1 }), Type.literal({ CONTACT_LENS_SUBSCRIPTION: 1 }));
var contactLensSubscriptionProductSpec = Type.interface(__assign(__assign({ attributesType: contactLensSubscriptionAttributeTypes }, productSchemaBase), { lineItemDetail: Type.interface({ bundleLineItems: Type.array(contactLensSubscriptionItem) }), typeDetails: Type.interface({
        billingFrequency: Type.literal({
            MONTHLY: 1,
            QUARTERLY: 1,
        }),
        deliveryFrequency: Type.literal({
            MONTHLY: 1,
            QUARTERLY: 1,
        }),
        subscriptionStartDate: Type.string,
        prescription: Type.interface({
            leftLens: optional(lensPrescription),
            rightLens: optional(lensPrescription),
        }),
    }) }));
var otherProductSpec = Type.interface(__assign(__assign({ attributesType: optional(Type.literal({})) }, productSchemaBase), { attributes: Type.interface({}) }));
__assign(__assign(__assign(__assign(__assign(__assign(__assign(__assign(__assign({}, contactLensAttributeTypes), contactLensSubscriptionAttributeTypes), solutionAttributeTypes), sunglassesAttributeTypes), framesAttributeTypes), contactLensBundleAttributeTypes), prescriptionGlassesAttributeTypes), readyReadersAttributeTypes), nonPrescriptionBundlesTypes);
var lineItemSchemaBase = {
    catalogPrice: money,
    discountedPrice: optional(money),
    totalPrice: optional(money),
    includedDiscountDescription: optional(localizedStringSpec$1),
    quantity: integerAbove0,
};
Type.interface(__assign({ product: nonPrescriptionBundleProductSpec }, lineItemSchemaBase));
Type.interface(__assign({ product: prescriptionGlassesProductSpec }, lineItemSchemaBase));
Type.interface(__assign({ product: contactLensesProductSpec }, lineItemSchemaBase));
Type.interface(__assign({ product: contactLensesBundleSpec }, lineItemSchemaBase));
Type.interface(__assign({ product: solutionProductSpec }, lineItemSchemaBase));
Type.interface(__assign({ product: framesProductSpec }, lineItemSchemaBase));
Type.interface(__assign({ product: sunglassesProductSpec }, lineItemSchemaBase));
Type.interface(__assign({ product: contactLensSubscriptionProductSpec }, lineItemSchemaBase));
Type.interface(__assign({ product: otherProductSpec }, lineItemSchemaBase));
Type.interface(__assign({ product: readyReadersProductSpec }, lineItemSchemaBase));
var historyLineItem = Type.interface(__assign({ product: either(contactLensesProductSpec, contactLensesBundleSpec, solutionProductSpec, framesProductSpec, sunglassesProductSpec, nonPrescriptionBundleProductSpec, prescriptionGlassesProductSpec, contactLensSubscriptionProductSpec, otherProductSpec, readyReadersProductSpec) }, lineItemSchemaBase));
var detailsLineItem = Type.interface(__assign({ product: either(contactLensesProductDetailsSpec, contactLensesBundleSpec, solutionProductSpec, framesProductSpec, sunglassesProductSpec, nonPrescriptionBundleProductSpec, prescriptionGlassesProductSpec, contactLensSubscriptionProductSpec, otherProductSpec, readyReadersProductSpec) }, lineItemSchemaBase));
var orderBaseSchema = {
    provider: Type.string,
    orderNumber: constrain(Type.string, [Constraint.string.regex(/^[0-9]+$/)]),
    orderDate: dateStringSpec,
    shipmentState: optional(Type.literal({
        Shipped: 1,
        Ready: 1,
        Pending: 1,
        Delayed: 1,
        Partial: 1,
        Backorder: 1,
    })),
    paymentMethod: optional(Type.literal({
        bancontactCard: 1,
        cashOnDelivery: 1,
        creditcard: 1,
        fake: 1,
        ideal: 1,
        klarna_account: 1,
        klarna: 1,
        mbway: 1,
        mobilepay: 1,
        multibanco: 1,
        paypal: 1,
        sepadirectdebit: 1,
    })),
    paymentState: optional(Type.literal({
        BalanceDue: 1,
        CreditOwed: 1,
        Failed: 1,
        Paid: 1,
        Pending: 1,
    })),
    totalChargedPrice: money,
    trackingURL: optional(Type.string),
};
var orderHistoryItemSpec = Type.interface(__assign(__assign({}, orderBaseSchema), { lineItems: Type.array(historyLineItem) }));
var orderHistoryResponseSpec = Type.interface({
    orders: Type.array(orderHistoryItemSpec),
    total: positiveIntegerSpec,
});
var orderDetailsItemSpec = Type.interface(__assign(__assign({}, orderBaseSchema), { lineItems: Type.array(detailsLineItem), totalProductsPrice: money, shippingPrice: money, totalAdditionalDiscount: money, shippingAddress: addressSpec, billingAddress: addressSpec, shippingInfo: Type.interface({
        deliveryMethod: Type.string,
    }), customerInfo: Type.interface({
        email: Type.string,
        phone: optional(Type.string),
    }) }));
var orderDetailsResponseSpec = Type.interface({
    order: orderDetailsItemSpec,
});

var details = function (apiUrl, accessToken, request) { return __awaiter(void 0, void 0, void 0, function () {
    var _a, _b;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0:
                _a = validateResponse;
                _b = [orderDetailsResponseSpec];
                return [4 /*yield*/, fetch(apiUrl + "/customer/" + request.customerId + "/details/" + request.orderId, {
                        method: 'GET',
                        headers: __assign(__assign({}, acceptJson), authHeader(accessToken)),
                    })];
            case 1: return [2 /*return*/, _a.apply(void 0, _b.concat([_c.sent()]))];
        }
    });
}); };
var legacyDetails = function (apiUrl, accessToken, request) { return __awaiter(void 0, void 0, void 0, function () {
    var _a, _b;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0:
                _a = validateResponse;
                _b = [orderDetailsResponseSpec];
                return [4 /*yield*/, fetch(apiUrl + "/archives/customer/" + request.customerId + "/details/" + request.orderId + "/crm", {
                        method: 'GET',
                        headers: __assign(__assign({}, acceptJson), authHeader(accessToken)),
                    })];
            case 1: return [2 /*return*/, _a.apply(void 0, _b.concat([_c.sent()]))];
        }
    });
}); };

// Deprecated types
var DEPRECATED_FRAMES_TYPE = 'frames';
var DEPRECATED_CONTACT_LENSES_TYPE = 'Contact-lenses';
var DEPRECATED_CONTACT_LENS_BUNDLE_TYPE = 'Contact-lens-bundles';
var DEPRECATED_SUNGLASSES_TYPE = 'sunglasses';
var DEPRECATED_SOLUTION_TYPE = 'Solutions';
var DEPRECATED_NON_PRESCRIPTION_BUNDLE = 'nonPrescriptionBundle';
var DEPRECATED_PRESCRIPTION_GLASSES = 'prescriptionGlasses';
// This one isn't updated in the backend yet but should be upper case eventually
var DEPRECATED_CONTACT_LENS_SUBSCRIPTION_TYPE = 'contactLensSubscription';
// New unified attribute types
var FRAMES_TYPE = 'FRAMES';
var CONTACT_LENSES_TYPE = 'CONTACT_LENSES';
var CONTACT_LENS_BUNDLE_TYPE = 'CONTACT_LENS_BUNDLES';
var SUNGLASSES_TYPE = 'SUNGLASSES';
var SOLUTION_TYPE = 'SOLUTIONS';
var NON_PRESCRIPTION_BUNDLE = 'NON_PRESCRIPTION_BUNDLE';
var PRESCRIPTION_GLASSES = 'PRESCRIPTION_GLASSES';
var CONTACT_LENS_SUBSCRIPTION_TYPE = 'CONTACT_LENS_SUBSCRIPTION';
var READY_READERS_TYPE = 'READY_READERS';
var isSubscriptionOrderLineItem = function (orderLineItem) { return isSubscriptionProduct(orderLineItem.product); };
var isSubscriptionProduct = function (product) {
    return product.attributesType === CONTACT_LENS_SUBSCRIPTION_TYPE ||
        product.attributesType === DEPRECATED_CONTACT_LENS_SUBSCRIPTION_TYPE;
};
var isContactLenses = function (product) {
    return product.attributesType === CONTACT_LENSES_TYPE ||
        product.attributesType === DEPRECATED_CONTACT_LENSES_TYPE;
};
var isContactLensesLineItem = function (orderLineItem) { return isContactLenses(orderLineItem.product); };
var isContactLensesSubscriptionLineItem = function (orderLineItem) {
    return isContactLensesSubscription(orderLineItem.product);
};
var isContactLensBundleLineItem = function (orderLineItem) { return isContactLensesBundle(orderLineItem.product); };
var isContactLensesSubscription = function (product) {
    return product.attributesType === CONTACT_LENS_SUBSCRIPTION_TYPE ||
        product.attributesType === DEPRECATED_CONTACT_LENS_SUBSCRIPTION_TYPE;
};
var isFrames = function (product) {
    return product.attributesType === FRAMES_TYPE || product.attributesType === DEPRECATED_FRAMES_TYPE;
};
var isContactLensesBundle = function (product) {
    return product.attributesType === CONTACT_LENS_BUNDLE_TYPE ||
        product.attributesType === DEPRECATED_CONTACT_LENS_BUNDLE_TYPE;
};
var isDetailContactLenses = function (product) {
    return product.attributesType === CONTACT_LENSES_TYPE ||
        product.attributesType === DEPRECATED_CONTACT_LENSES_TYPE;
};
var isDetailContactLensesSubscriptionProduct = function (product) {
    return product.attributesType === CONTACT_LENS_SUBSCRIPTION_TYPE ||
        product.attributesType === DEPRECATED_CONTACT_LENS_SUBSCRIPTION_TYPE;
};
var isDetailContactLensesSubscriptionLineItem = function (lineItem) {
    return isDetailContactLensesSubscriptionProduct(lineItem.product);
};
var isPrescriptionGlasses = function (product) {
    return product.attributesType === PRESCRIPTION_GLASSES ||
        product.attributesType === DEPRECATED_PRESCRIPTION_GLASSES;
};
var isNonPrescriptionBundle = function (product) {
    return product.attributesType === DEPRECATED_NON_PRESCRIPTION_BUNDLE ||
        product.attributesType === NON_PRESCRIPTION_BUNDLE;
};
var isPrescriptionGlassesLineItem = function (lineItem) { return isPrescriptionGlasses(lineItem.product); };
var isNonPrescriptionBundleLineItem = function (lineItem) { return isNonPrescriptionBundle(lineItem.product); };
var isSolutionLineItem = function (lineItem) { return isSolution(lineItem.product); };
var isPrescriptionBundleInArray = function (items) {
    return items.some(function (item) { return isPrescriptionGlasses(item.product); });
};
var isSubscriptionItemInArray = function (items) {
    return items.some(function (item) { return isContactLensesSubscription(item.product); });
};
var isNonPrescriptionBundleInArray = function (items) {
    return items.some(function (item) { return isNonPrescriptionBundle(item.product); });
};
var isDetailContactLensBundles = function (product) {
    return product.attributesType === CONTACT_LENS_BUNDLE_TYPE ||
        product.attributesType === DEPRECATED_CONTACT_LENS_BUNDLE_TYPE;
};
var isSunglassesLineItem = function (orderLineItem) {
    return orderLineItem.product.attributesType === SUNGLASSES_TYPE ||
        orderLineItem.product.attributesType === DEPRECATED_SUNGLASSES_TYPE;
};
var isSunglasses = function (product) {
    return product.attributesType === SUNGLASSES_TYPE ||
        product.attributesType === DEPRECATED_SUNGLASSES_TYPE;
};
var isSolution = function (product) {
    return product.attributesType === SOLUTION_TYPE || product.attributesType === DEPRECATED_SOLUTION_TYPE;
};
var isOther = function (product) {
    return product.attributesType === undefined || !CONTACT_LENSES_TYPE || !SOLUTION_TYPE;
};
var isReadyReadersLineItem = function (orderLineItem) {
    return orderLineItem.product.attributesType === READY_READERS_TYPE;
};
var isReadyReaders = function (product) {
    return product.attributesType === READY_READERS_TYPE;
};

var list$1 = function (apiUrl, accessToken, request) { return __awaiter(void 0, void 0, void 0, function () {
    var _a, _b;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0:
                _a = validateResponse;
                _b = [orderHistoryResponseSpec];
                return [4 /*yield*/, fetch(apiUrl + "/customer/" + request.customerId + "/history?offset=" + request.offset + "&limit=" + request.limit, {
                        method: 'GET',
                        headers: __assign(__assign({}, acceptJson), authHeader(accessToken)),
                    })];
            case 1: return [2 /*return*/, _a.apply(void 0, _b.concat([_c.sent()]))];
        }
    });
}); };
var legacyList = function (apiUrl, accessToken, request) { return __awaiter(void 0, void 0, void 0, function () {
    var _a, _b;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0:
                _a = validateResponse;
                _b = [orderHistoryResponseSpec];
                return [4 /*yield*/, fetch(apiUrl + "/archives/customer/" + request.customerId + "/history/crm?offset=" + request.offset + "&limit=" + request.limit, {
                        method: 'GET',
                        headers: __assign(__assign({}, acceptJson), authHeader(accessToken)),
                    })];
            case 1: return [2 /*return*/, _a.apply(void 0, _b.concat([_c.sent()]))];
        }
    });
}); };

var getOrderByToken = function (apiUrl, request) { return __awaiter(void 0, void 0, void 0, function () {
    var orderData, _a;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0:
                orderData = request.orderData;
                _a = unwrapResponse;
                return [4 /*yield*/, fetch(apiUrl + "/" + orderData, {
                        method: 'GET',
                        headers: __assign({}, acceptJson),
                    })];
            case 1: return [2 /*return*/, _a.apply(void 0, [_b.sent()])];
        }
    });
}); };

var unlink = function (apiUrl, request) { return __awaiter(void 0, void 0, void 0, function () {
    var orderNumber, orderToken, response;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                orderNumber = request.orderNumber, orderToken = request.orderToken;
                return [4 /*yield*/, fetch(apiUrl + "/orders/" + orderNumber + "/customer?orderDataToken=" + orderToken, {
                        method: 'DELETE',
                        headers: __assign({}, acceptJson),
                    })];
            case 1:
                response = _a.sent();
                okOrThrow(response);
                return [2 /*return*/, response];
        }
    });
}); };

var index$6 = /*#__PURE__*/Object.freeze({
    __proto__: null,
    create: create,
    createForCustomer: createForCustomer,
    details: details,
    legacyDetails: legacyDetails,
    isSubscriptionOrderLineItem: isSubscriptionOrderLineItem,
    isSubscriptionProduct: isSubscriptionProduct,
    isContactLenses: isContactLenses,
    isContactLensesLineItem: isContactLensesLineItem,
    isContactLensesSubscriptionLineItem: isContactLensesSubscriptionLineItem,
    isContactLensBundleLineItem: isContactLensBundleLineItem,
    isContactLensesSubscription: isContactLensesSubscription,
    isFrames: isFrames,
    isContactLensesBundle: isContactLensesBundle,
    isDetailContactLenses: isDetailContactLenses,
    isDetailContactLensesSubscriptionProduct: isDetailContactLensesSubscriptionProduct,
    isDetailContactLensesSubscriptionLineItem: isDetailContactLensesSubscriptionLineItem,
    isPrescriptionGlasses: isPrescriptionGlasses,
    isNonPrescriptionBundle: isNonPrescriptionBundle,
    isPrescriptionGlassesLineItem: isPrescriptionGlassesLineItem,
    isNonPrescriptionBundleLineItem: isNonPrescriptionBundleLineItem,
    isSolutionLineItem: isSolutionLineItem,
    isPrescriptionBundleInArray: isPrescriptionBundleInArray,
    isSubscriptionItemInArray: isSubscriptionItemInArray,
    isNonPrescriptionBundleInArray: isNonPrescriptionBundleInArray,
    isDetailContactLensBundles: isDetailContactLensBundles,
    isSunglassesLineItem: isSunglassesLineItem,
    isSunglasses: isSunglasses,
    isSolution: isSolution,
    isOther: isOther,
    isReadyReadersLineItem: isReadyReadersLineItem,
    isReadyReaders: isReadyReaders,
    list: list$1,
    legacyList: legacyList,
    getOrderByToken: getOrderByToken,
    unlink: unlink
});

var completeAdyenPayment = function (apiUrl, request) { return __awaiter(void 0, void 0, void 0, function () {
    var details, paymentData, paymentId, _a;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0:
                details = request.details, paymentData = request.paymentData, paymentId = request.paymentId;
                _a = unwrapResponse;
                return [4 /*yield*/, fetch(apiUrl + "/payments/adyen/complete", {
                        method: 'POST',
                        headers: __assign(__assign({}, acceptJson), postJson),
                        body: JSON.stringify({ details: details, paymentData: paymentData, paymentId: paymentId }),
                    })];
            case 1: return [2 /*return*/, _a.apply(void 0, [_b.sent()])];
        }
    });
}); };
var completeAdyenRedirectPayment = function (apiUrl, request) { return __awaiter(void 0, void 0, void 0, function () {
    var details, paymentData, paymentId, _a;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0:
                details = request.details, paymentData = request.paymentData, paymentId = request.paymentId;
                _a = unwrapResponse;
                return [4 /*yield*/, fetch(apiUrl + "/payments/adyen/complete", {
                        method: 'POST',
                        headers: __assign(__assign({}, acceptJson), postJson),
                        body: JSON.stringify({ details: details, paymentData: paymentData, paymentId: paymentId }),
                    })];
            case 1: return [2 /*return*/, _a.apply(void 0, [_b.sent()])];
        }
    });
}); };
var completeAdyen3DSecurePayment = function (apiUrl, request) { return __awaiter(void 0, void 0, void 0, function () {
    var details, paymentData, paymentId, _a;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0:
                details = request.details, paymentData = request.paymentData, paymentId = request.paymentId;
                _a = unwrapResponse;
                return [4 /*yield*/, fetch(apiUrl + "/payments/adyen/complete", {
                        method: 'POST',
                        headers: __assign(__assign({}, acceptJson), postJson),
                        body: JSON.stringify({ details: details, paymentData: paymentData, paymentId: paymentId }),
                    })];
            case 1: return [2 /*return*/, _a.apply(void 0, [_b.sent()])];
        }
    });
}); };

var index$5 = /*#__PURE__*/Object.freeze({
    __proto__: null,
    completeAdyenPayment: completeAdyenPayment,
    completeAdyenRedirectPayment: completeAdyenRedirectPayment,
    completeAdyen3DSecurePayment: completeAdyen3DSecurePayment
});

var getPaymentMethods = function (apiUrl, request) { return __awaiter(void 0, void 0, void 0, function () {
    var countryCode, shippingMethod, isSubscription, cartId, _a;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0:
                countryCode = request.countryCode, shippingMethod = request.shippingMethod, isSubscription = request.isSubscription, cartId = request.cartId;
                _a = unwrapResponse;
                return [4 /*yield*/, fetch(apiUrl + "/paymentMethods", {
                        method: 'POST',
                        headers: __assign(__assign({}, acceptJson), postJson),
                        body: JSON.stringify({ countryCode: countryCode, shippingMethod: shippingMethod, isSubscription: isSubscription, cartId: cartId }),
                    })];
            case 1: return [2 /*return*/, _a.apply(void 0, [_b.sent()])];
        }
    });
}); };

var PaymentMethod;
(function (PaymentMethod) {
    PaymentMethod["BancontactCard"] = "bancontactCard";
    PaymentMethod["CashOnDelivery"] = "cashOnDelivery";
    PaymentMethod["Creditcard"] = "creditcard";
    PaymentMethod["Fake"] = "fake";
    PaymentMethod["Ideal"] = "ideal";
    PaymentMethod["Klarna"] = "klarna";
    PaymentMethod["KlarnaAccount"] = "klarna_account";
    PaymentMethod["MBway"] = "mbway";
    PaymentMethod["MobilePay"] = "mobilepay";
    PaymentMethod["Multibanco"] = "multibanco";
    PaymentMethod["Oney"] = "oney";
    PaymentMethod["Paypal"] = "paypal";
    PaymentMethod["SepaDirectDebit"] = "sepadirectdebit";
})(PaymentMethod || (PaymentMethod = {}));
var PaymentServiceProvider;
(function (PaymentServiceProvider) {
    PaymentServiceProvider["Adyen"] = "adyen";
    PaymentServiceProvider["Fake"] = "fake";
    PaymentServiceProvider["CashOnDelivery"] = "cashOnDelivery";
})(PaymentServiceProvider || (PaymentServiceProvider = {}));
var PaymentResult;
(function (PaymentResult) {
    PaymentResult["Success"] = "success";
    PaymentResult["Pending"] = "pending";
    PaymentResult["Failed"] = "failed";
    PaymentResult["Redirect"] = "redirect";
})(PaymentResult || (PaymentResult = {}));
var Gender;
(function (Gender) {
    Gender["Male"] = "MALE";
    Gender["Female"] = "FEMALE";
    Gender["Unknown"] = "UNKNOWN";
})(Gender || (Gender = {}));
var CartState;
(function (CartState) {
    CartState["Active"] = "Active";
    CartState["Merged"] = "Merged";
    CartState["Ordered"] = "Ordered";
})(CartState || (CartState = {}));
/**
 * Adyen callback result codes
 */
var CallbackResultCode;
(function (CallbackResultCode) {
    CallbackResultCode["Authorised"] = "authorised";
    CallbackResultCode["Cancelled"] = "cancelled";
    CallbackResultCode["Refused"] = "refused";
    CallbackResultCode["Pending"] = "pending";
    CallbackResultCode["Received"] = "received";
})(CallbackResultCode || (CallbackResultCode = {}));

var types$2 = /*#__PURE__*/Object.freeze({
    __proto__: null,
    get PaymentMethod () { return PaymentMethod; },
    get PaymentServiceProvider () { return PaymentServiceProvider; },
    get PaymentResult () { return PaymentResult; },
    get CartState () { return CartState; },
    get CallbackResultCode () { return CallbackResultCode; }
});

var index$4 = /*#__PURE__*/Object.freeze({
    __proto__: null,
    Adyen: index$5,
    getPaymentMethods: getPaymentMethods,
    get PaymentMethod () { return PaymentMethod; },
    get PaymentServiceProvider () { return PaymentServiceProvider; },
    get PaymentResult () { return PaymentResult; },
    get CartState () { return CartState; },
    get CallbackResultCode () { return CallbackResultCode; }
});

var query = function (apiUrl, request) { return __awaiter(void 0, void 0, void 0, function () {
    var category, expand, facets, filters, pageIndex, pageSize, sortBy, sortDirection, queryParams, endpoint, _a;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0:
                category = (request && request.categoryType) || undefined;
                expand = request && request.expand ? request.expand.join('|') : undefined;
                facets = request && request.facets ? request.facets.join('|') : undefined;
                filters = request && request.filters ? request.filters.join('|') : undefined;
                pageIndex = (request && request.pageIndex) || 1;
                pageSize = (request && request.pageSize) || 24;
                sortBy = (request && request.sortBy) || 'price';
                sortDirection = (request && request.sortDirection) || 'asc';
                queryParams = QueryString.stringify({
                    expand: expand,
                    filters: filters,
                    facets: facets,
                    pageIndex: pageIndex,
                    pageSize: pageSize,
                    sortBy: sortBy,
                    sortDirection: sortDirection,
                }, true, '&', '=', false);
                endpoint = category ? "/category/" + category + "/" : '/';
                _a = unwrapResponse;
                return [4 /*yield*/, fetch("" + apiUrl + endpoint + "?" + queryParams, {
                        method: 'GET',
                        headers: __assign(__assign({}, acceptJson), postJson),
                    })];
            case 1: return [2 /*return*/, _a.apply(void 0, [_b.sent()])];
        }
    });
}); };

var getProductById = function (apiUrl, request) { return __awaiter(void 0, void 0, void 0, function () {
    var expand, _a;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0:
                expand = request.expand ? request.expand.join('|') : null;
                _a = unwrapResponse;
                return [4 /*yield*/, fetch(apiUrl + "/" + request.productId + "?expand=" + expand, {
                        method: 'GET',
                        headers: __assign(__assign({}, acceptJson), postJson),
                    })];
            case 1: return [2 /*return*/, _a.apply(void 0, [_b.sent()])];
        }
    });
}); };
var getProductBySlug = function (apiUrl, request) { return __awaiter(void 0, void 0, void 0, function () {
    var expands, _a;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0:
                expands = request.expand || [
                    'attributes',
                    'tax-category',
                    'discounts',
                    'categories',
                    'product-type',
                    'review-enabled',
                ];
                _a = unwrapResponse;
                return [4 /*yield*/, fetch(apiUrl + "/slug/" + request.slug + "?expand=" + expands.join('|'), {
                        method: 'GET',
                        headers: __assign(__assign({}, acceptJson), postJson),
                    })];
            case 1: return [2 /*return*/, _a.apply(void 0, [_b.sent()])];
        }
    });
}); };

var getCategoryByKey = function (apiUrl, request) { return __awaiter(void 0, void 0, void 0, function () {
    var _a;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0:
                _a = unwrapResponse;
                return [4 /*yield*/, fetch(apiUrl + "/categories/" + request.key, {
                        method: 'GET',
                        headers: __assign(__assign({}, acceptJson), postJson),
                    })];
            case 1: return [2 /*return*/, _a.apply(void 0, [_b.sent()])];
        }
    });
}); };

var getContactLenses = function (apiUrl, request) { return __awaiter(void 0, void 0, void 0, function () {
    var _a;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0:
                _a = unwrapResponse;
                return [4 /*yield*/, fetch(apiUrl + "/contactlenses/" + request.variantGroup, {
                        method: 'GET',
                        headers: __assign(__assign({}, acceptJson), postJson),
                    })];
            case 1: return [2 /*return*/, _a.apply(void 0, [_b.sent()])];
        }
    });
}); };
var getContactLensBundles = function (apiUrl, request) { return __awaiter(void 0, void 0, void 0, function () {
    var expands, queryParams, _a;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0:
                expands = [
                    'masterVariant.prices[*].discounted.discount',
                    'variants[*].prices[*].discounted.discount',
                    'masterVariant.attributes[*].value',
                    'productType',
                ];
                queryParams = QueryString.stringify({
                    expand: expands.join('|'),
                    filters: "variants.sku:\"" + request.sku + "\"",
                    solutions: true,
                }, true, '&', '=', false);
                _a = unwrapResponse;
                return [4 /*yield*/, fetch(apiUrl + "/?" + queryParams, {
                        method: 'GET',
                        headers: __assign(__assign({}, acceptJson), postJson),
                    })];
            case 1: return [2 /*return*/, _a.apply(void 0, [_b.sent()])];
        }
    });
}); };

var index$3 = /*#__PURE__*/Object.freeze({
    __proto__: null,
    query: query,
    getProductById: getProductById,
    getProductBySlug: getProductBySlug,
    getCategoryByKey: getCategoryByKey,
    getContactLenses: getContactLenses,
    getContactLensBundles: getContactLensBundles
});

function getVersion(apiUrl) {
    return __awaiter(this, void 0, void 0, function () {
        var url, _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    url = new URL('status/versions', apiUrl);
                    _a = unwrapResponse;
                    return [4 /*yield*/, fetch(url.href)];
                case 1: return [2 /*return*/, _a.apply(void 0, [_b.sent(), { useResponseError: true }])];
            }
        });
    });
}

var index$2 = /*#__PURE__*/Object.freeze({
    __proto__: null,
    getVersion: getVersion
});

var localizedStringSpec = Type.map(Type.string, Type.string);
var townItem = Type.interface({
    town: Type.string,
    townLocalized: optional(localizedStringSpec),
});
var townsResponseSpec = Type.array(townItem);
var storeSitemapItem = Type.interface({
    slug: Type.string,
    slugLocalized: optional(localizedStringSpec),
    town: Type.string,
    townLocalized: optional(localizedStringSpec),
});
var storeSitemapResponseSpec = Type.array(storeSitemapItem);

var getTowns = function (apiUrl) { return __awaiter(void 0, void 0, void 0, function () {
    var _a, _b;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0:
                _a = validateResponse;
                _b = [townsResponseSpec];
                return [4 /*yield*/, fetch(apiUrl + "/towns", {
                        method: 'GET',
                        headers: __assign({}, acceptJson),
                    })];
            case 1: return [2 /*return*/, _a.apply(void 0, _b.concat([_c.sent()]))];
        }
    });
}); };

/**
 * Lists all stores for an opco
 */
var list = function (apiUrl) { return __awaiter(void 0, void 0, void 0, function () {
    var _a;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0:
                _a = unwrapResponse;
                return [4 /*yield*/, fetch(apiUrl + "/list", {
                        method: 'GET',
                        headers: __assign({}, acceptJson),
                    })];
            case 1: return [2 /*return*/, _a.apply(void 0, [_b.sent()])];
        }
    });
}); };
/**
 * Retrieve details of a single store using the store code.
 */
var getDetailsByCode = function (apiUrl, request) { return __awaiter(void 0, void 0, void 0, function () {
    var _a;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0:
                _a = unwrapResponse;
                return [4 /*yield*/, fetch(apiUrl + "/" + request.code, {
                        method: 'GET',
                        headers: __assign({}, acceptJson),
                    })];
            case 1: return [2 /*return*/, _a.apply(void 0, [_b.sent()])];
        }
    });
}); };
/**
 * Function to retrieve a list of stores based on a filter parameter
 * Currently only supports slug lookup
 */
var getStoresByFilter = function (apiUrl, request) { return __awaiter(void 0, void 0, void 0, function () {
    var _a;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0:
                _a = unwrapResponse;
                return [4 /*yield*/, fetch(apiUrl + "/retrieve/filter?name=" + request.filter + "&value=" + request.value, {
                        method: 'GET',
                        headers: __assign({}, acceptJson),
                    })];
            case 1: return [2 /*return*/, _a.apply(void 0, [_b.sent()])];
        }
    });
}); };

var getStoreSitemap = function (apiUrl) { return __awaiter(void 0, void 0, void 0, function () {
    var _a, _b;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0:
                _a = validateResponse;
                _b = [storeSitemapResponseSpec];
                return [4 /*yield*/, fetch(apiUrl + "/sitemap", {
                        method: 'GET',
                        headers: __assign({}, acceptJson),
                    })];
            case 1: return [2 /*return*/, _a.apply(void 0, _b.concat([_c.sent()]))];
        }
    });
}); };

var index$1 = /*#__PURE__*/Object.freeze({
    __proto__: null,
    getTowns: getTowns,
    list: list,
    getDetailsByCode: getDetailsByCode,
    getStoresByFilter: getStoresByFilter,
    getStoreSitemap: getStoreSitemap
});

var types$1 = /*#__PURE__*/Object.freeze({
    __proto__: null
});

var getConfigResponse = Type.interface({
    scope: Type.string,
    maxFileSizeBytes: Type.number,
    maxFileNameLength: Type.number,
    allowedFileTypes: optional(Type.array(Type.string)),
    isRecaptchaTokenRequired: Type.boolean,
});
var getUploadTokenResponse = Type.interface({
    scope: Type.string,
    token: Type.string,
});
var sendFileResponse = Type.interface({
    scope: Type.string,
    storageId: Type.string,
    storageToken: Type.string,
});

var getConfig = function (apiUrl, _a, init) {
    var scope = _a.scope;
    return __awaiter(void 0, void 0, void 0, function () {
        var _b, _c;
        return __generator(this, function (_d) {
            switch (_d.label) {
                case 0:
                    _b = validateResponse;
                    _c = [getConfigResponse];
                    return [4 /*yield*/, fetch(apiUrl + "/upload/config/" + scope, __assign({ method: 'GET', headers: __assign({}, acceptJson) }, init))];
                case 1: return [2 /*return*/, _b.apply(void 0, _c.concat([_d.sent()]))];
            }
        });
    });
};

var getUploadToken = function (apiUrl, _a, init) {
    var scope = _a.scope, referenceId = _a.referenceId, recaptchaToken = _a.recaptchaToken;
    return __awaiter(void 0, void 0, void 0, function () {
        var formData, _b, _c;
        return __generator(this, function (_d) {
            switch (_d.label) {
                case 0:
                    formData = new FormData();
                    formData.append('scope', scope);
                    formData.append('referenceId', referenceId);
                    if (recaptchaToken) {
                        formData.append('recaptchaToken', recaptchaToken);
                    }
                    _b = validateResponse;
                    _c = [getUploadTokenResponse];
                    return [4 /*yield*/, fetch(apiUrl + "/upload/token", __assign({ method: 'POST', body: formData }, init))];
                case 1: return [2 /*return*/, _b.apply(void 0, _c.concat([_d.sent()]))];
            }
        });
    });
};

var sendFile = function (apiUrl, _a, init) {
    var scope = _a.scope, referenceId = _a.referenceId, uploadedFile = _a.uploadedFile, uploadToken = _a.uploadToken, alias = _a.alias;
    return __awaiter(void 0, void 0, void 0, function () {
        var formData, _b, _c;
        return __generator(this, function (_d) {
            switch (_d.label) {
                case 0:
                    formData = new FormData();
                    formData.append('scope', scope);
                    formData.append('referenceId', referenceId);
                    formData.append('uploadedFile', uploadedFile, alias || uploadedFile.name);
                    _b = validateResponse;
                    _c = [sendFileResponse];
                    return [4 /*yield*/, fetch(apiUrl + "/upload/file", __assign({ method: 'POST', body: formData, headers: {
                                'x-upload-token': uploadToken,
                            } }, init))];
                case 1: return [2 /*return*/, _b.apply(void 0, _c.concat([_d.sent()]))];
            }
        });
    });
};

var types = /*#__PURE__*/Object.freeze({
    __proto__: null
});

var index = /*#__PURE__*/Object.freeze({
    __proto__: null,
    Types: types,
    getConfig: getConfig,
    getUploadToken: getUploadToken,
    sendFile: sendFile
});

var initialState = [true, undefined, undefined, false];
function reducer(state, action) {
    switch (action.type) {
        case 'RESET':
            return initialState;
        case 'CALLED':
            return [true, undefined, undefined, true];
        case 'SUCCESS':
            return [false, action.payload, undefined, true];
        case 'FAILURE':
            return [false, undefined, action.payload, true];
    }
}
/**
 * Use one of the api-client's functions as a hook. The first argument is the
 * API function itself. The rest of the argument are the API function's
 * parameters.
 *
 * For example:
 *
 *    const [loading, result, error] = useApiClient(
 *      Orders.list,
 *      apiUrl,
 *      accessToken,
 *      { customerId, limit, offset }
 *    )
 *
 *  Note: the type of the rest arguments and of `result` are inferred from the
 *  given API function.
 */
function useApiClient(apiFunc, options) {
    var params = [];
    for (var _i = 2; _i < arguments.length; _i++) {
        params[_i - 2] = arguments[_i];
    }
    var _a = __read(useReducer(reducer, initialState), 2), state = _a[0], dispatch = _a[1];
    useEffect(function () {
        var cancelled = false;
        dispatch({ type: 'RESET' });
        if (options && options.skip) {
            return;
        }
        dispatch({ type: 'CALLED' });
        apiFunc.apply(void 0, __spreadArray([], __read(params))).then(function (result) { return cancelled || dispatch({ type: 'SUCCESS', payload: result }); })
            .catch(function (error) { return cancelled || dispatch({ type: 'FAILURE', payload: error }); });
        return function () {
            cancelled = true;
        };
    }, __spreadArray([options && options.skip], __read(params)));
    return state;
}

export { index$g as AddressBook, index$f as Appointments, index$e as Carts, index$9 as Customers, index$8 as Location, index$7 as Optimizely, index$6 as Orders, types$2 as PaymentTypes, index$4 as Payments, index$3 as Products, index$2 as Status, index$1 as Stores, types$1 as Types, index as Upload, useApiClient };
//# sourceMappingURL=index.js.map
